import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { StyleSheet, TextInput, View, } from 'react-native';
export const InputNative = React.memo(function InputNative(props) {
    return (_jsxs(View, { style: [
            props.multiline
                ? styles.TokyoTextInputMultiline
                : styles.TokyoTextInput,
            props.containerStyle ?? {},
        ], children: [props.startEnhancer, _jsx(TextInput, { style: styles.innerTextInput, testID: props.testID, value: props.value, onChangeText: props.onChangeValue, keyboardType: props.keyboardType, autoFocus: props.autoFocus, placeholder: props.placeholder, placeholderTextColor: "#aaa", secureTextEntry: props.type === 'password', autoComplete: props.autoComplete, autoCapitalize: props.autoCapitalize, multiline: props.multiline, scrollEnabled: props.multiline !== true }), props.endEnhancer] }));
});
const styles = StyleSheet.create({
    TokyoTextInputMultiline: {
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 10,
        paddingRight: 10,
        fontSize: 16,
        minHeight: 60,
        borderColor: 'white',
        borderWidth: 0,
        backgroundColor: '#37363a',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: 'white',
        borderRadius: 10,
        fontFamily: 'hiyllo',
        letterSpacing: 0.25,
    },
    TokyoTextInput: {
        paddingLeft: 10,
        paddingRight: 10,
        fontSize: 16,
        height: 40,
        borderColor: 'white',
        borderWidth: 0,
        backgroundColor: '#37363a',
        color: 'white',
        borderRadius: 10,
        fontFamily: 'hiyllo',
        letterSpacing: 0.25,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    innerTextInput: {
        minHeight: 40,
        color: 'white',
        width: 0,
        flexGrow: 1,
    },
});
